export default "__VITE_ASSET__ay3sAxqG__"